import { writable } from 'svelte/store'
import Cookies from 'js-cookie'

export const supportedCountries = ['FI', 'SE']

export const createCountry = () => {
    // Get country from cookies, either saved chosen country or from geolocation cookie set on the edge
    // or set default to Finland
    const country = Cookies.get('chosen-country') || Cookies.get('nf-geo-country-code') || 'FI'

    return writable(country)
}
